import { Log } from '@lightningjs/sdk';
import { DetailTranslationKeys, SettingsKeys } from '../../api/models/TranslationKeys';
import { AssetType, CardSize, CmsProperty } from '../../api/models/Shared.types';
import { RecommendationsUrlBuilder } from './RecommendationsUrlBuilder';
import { RibbonDataSource } from '../cms/RibbonDataSource';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';

export class DetailDataSource {
  protected backend: Backend;
  constructor(backend: Backend) {
    this.backend = backend;
  }

  load(id: string) {
    Log.error('[DetailDataSource]', 'load not implemented', id);
  }

  logPageView() {
    Log.warn('[DetailDataSource', 'logPageView not implemented');
  }

  createRelatedDataSources(
    backend: Backend,
    type: AssetType | string,
    assetId: string,
    epg = false,
    channels: ChannelModel[] = []
  ): RibbonDataSource[] {
    const result = [];

    let othersLikedProperties = backend.globalSettings.stringArray(SettingsKeys.propertiesVodDetailOthersLikedRibbon);
    othersLikedProperties = othersLikedProperties
      ? othersLikedProperties
      : epg
      ? [CmsProperty.ShowProgress, CmsProperty.UseBestSchedule, CmsProperty.ShowScheduleInfo]
      : [CmsProperty.ShowProgress, CmsProperty.HideInfo];

    const OthersLikedRibbon = {
      title: backend.translations.forKey(DetailTranslationKeys.detail_recommended_others_watched),
      properties: othersLikedProperties,
      url: epg
        ? RecommendationsUrlBuilder.epgOthersLikedUrl(backend, type, assetId)
        : RecommendationsUrlBuilder.vodOthersLikedUrl(backend, type, assetId),
      message: 'No others-liked VODs',
      cardSize: CardSize.Normal,
    };
    result.push(new RibbonDataSource(backend, OthersLikedRibbon, [], channels));

    let vodSimilarProperties = backend.globalSettings.stringArray(SettingsKeys.propertiesVodDetailSimilarRibbon);
    vodSimilarProperties = vodSimilarProperties
      ? vodSimilarProperties
      : epg
      ? [CmsProperty.ShowProgress, CmsProperty.UseBestSchedule, CmsProperty.ShowScheduleInfo]
      : [CmsProperty.ShowProgress, CmsProperty.HideInfo];

    const vodSimilarRibbon = {
      title: backend.translations.forKey(DetailTranslationKeys.detail_recommended_more_like_this),
      properties: vodSimilarProperties,
      url: epg
        ? RecommendationsUrlBuilder.epgSimilarUrl(backend, type, assetId)
        : RecommendationsUrlBuilder.vodSimilarUrl(backend, type, assetId),
      message: 'No similar VODs',
      cardSize: CardSize.Normal,
    };
    result.push(new RibbonDataSource(backend, vodSimilarRibbon, [], channels));

    return result;
  }
}
